export const WriteModeEnum = {
  CREATE: 'create',
  EDIT: 'edit',
};
